<template>
    <div class="xq">
        <el-form ref="form" :model="form" :rules="rules" label-width="110px" class="dwxq">
            <el-form-item label="当事人类型:" prop="jingyingzhe" class="jy" style="margin-bottom: 12px;">
                <el-radio-group v-model="form.jingyingzhe" :disabled="states==1?true:false">
                    <el-radio label="公民"></el-radio>
                    <el-radio label="法人"></el-radio>
                    <el-radio label="个体工商户"></el-radio>
                    <el-radio label="其他组织"></el-radio>
                </el-radio-group>
            </el-form-item>
            <el-col :span="24">
                <div class="bd">
                    <p>当事人基本信息</p>
                    <div class="nr" v-if="form.jingyingzhe == '公民'">
                        <el-row>
                            <el-col :span="8">
                                <el-form-item label="个人:" prop="dwmc">
                                    <el-input size="small" clearable :disabled="states==1?true:false" v-model="form.dwmc"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="住址:" prop="dwdz">
                                    <el-input size="small" clearable :disabled="states==1?true:false" v-model="form.dwdz"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="性别:" prop="frxb">
                                    <el-input size="small" clearable :disabled="states==1?true:false" v-model="form.frxb"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>   
                            <el-col :span="8">
                                <el-form-item label="民族:" prop="nation">
                                    <el-input size="small" clearable :disabled="states==1?true:false" v-model="form.nation"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="身份证号:" prop="sfzh">
                                    <el-input size="small" clearable :disabled="states==1?true:false" v-model="form.sfzh"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="联系电话:" prop="sj1">
                                    <el-input size="small" clearable :disabled="states==1?true:false" v-model="form.sj1"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item label="违法行为地址:">
                                    <el-input size="small" clearable :disabled="states==1?true:false" v-model="form.wfxwdz"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="违法行为场所:">
                                    <el-input size="small" clearable :disabled="states==1?true:false" v-model="form.changsuo"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="nr" v-else>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item label="当事人:" prop="dwmc">
                                    <el-input size="small" clearable :disabled="states==1?true:false" v-model="form.dwmc"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="地址:" prop="dwdz">
                                    <el-input size="small" clearable :disabled="states==1?true:false" v-model="form.dwdz"></el-input>
                                </el-form-item>
                            </el-col>
                            <!-- <el-col :span="8">
                                <el-form-item label="许可证号" prop="xkzh">
                                    <el-input size="small" clearable v-model="form.xkzh"></el-input>
                                </el-form-item>
                            </el-col> -->
                           
                            <el-col :span="8">
                                <el-form-item label="社会信用代码:">
                                    <el-input size="small" clearable :disabled="states==1?true:false" v-model="form.zzdm"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>     <el-col :span="8">
                                <el-form-item label="法定代表人:" prop="jingyingzhexm">
                                    <el-input size="small" clearable :disabled="states==1?true:false" v-model="form.jingyingzhexm"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <el-form-item label="性别:" prop="frxb">
                                    <el-select v-model="form.frxb" placeholder="请选择性别" clearable :disabled="states==1?true:false" size="small">
                                        <el-option  label="男" value="男"/>
                                        <el-option  label="女" value="女"/>
                                        <el-option  label="其他" value="其他"/>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <el-form-item label="民族:" prop="nation">
                                    <el-input size="small" clearable :disabled="states==1?true:false" v-model="form.nation"></el-input>
                                </el-form-item>
                            </el-col>
                        
                            <el-col :span="8">
                                <el-form-item label="身份证号:" prop="sfzh">
                                    <el-input size="small" clearable :disabled="states==1?true:false" v-model="form.sfzh"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>    <el-col :span="8">
                                <el-form-item label="联系电话:" prop="sj1">
                                    <el-input size="small" clearable :disabled="states==1?true:false" v-model="form.sj1"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <el-form-item label="职务:">
                                    <el-input size="small" clearable :disabled="states==1?true:false" v-model="form.frzw"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                    
                </div>    
                <div class="bd">
                    <p>案件基本信息</p>
                    <div class="nr">
                        <el-row>
                            <el-col :span="9">
                                <el-form-item label="案件来源:" prop="laiyuan">
                                    <el-input size="small" clearable :disabled="states==1?true:false" v-model="form.laiyuan"></el-input>
                                </el-form-item>
                            </el-col> 
                            <el-col :span="5">
                                <el-form-item label="检查日期:" prop="jiancha_rq">
                                    <el-date-picker size="small" clearable :disabled="states==1?true:false"
                                        v-model="form.jiancha_rq"
                                        type="date"
                                        placeholder="选择日期" value-format="yyyy-MM-dd" >
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="5">
                                <el-form-item label="受理日期:"  prop="shouli_rq">
                                    <el-date-picker size="small" clearable :disabled="states==1?true:false"
                                        v-model="form.shouli_rq"
                                        type="date"
                                        placeholder="选择日期" value-format="yyyy-MM-dd">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="5">
                                <el-form-item label="立案日期:" prop="lian_rq">
                                    <el-date-picker size="small" clearable :disabled="states==1?true:false"
                                        v-model="form.lian_rq"
                                        type="date"
                                        placeholder="选择日期" value-format="yyyy-MM-dd">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>    
                            <el-col :span="14">
                                <el-form-item label="合议日期:">
                                    <el-date-picker size="small" clearable :disabled="states==1?true:false" style="width:40%;"
                                        v-model="form.heyisj_begin"
                                        type="datetime"
                                        placeholder="选择日期"  value-format="yyyy-MM-dd HH:mm:ss">
                                    </el-date-picker>
                                    至
                                    <el-date-picker size="small" clearable :disabled="states==1?true:false" style="width:40%;"
                                        v-model="form.heyisj_end"
                                        type="datetime"
                                        placeholder="选择日期"  value-format="yyyy-MM-dd HH:mm:ss">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="5">
                                <el-form-item label="监督员1:" prop="host_man">
                                    <el-input size="small" clearable :disabled="states==1?true:false" v-model="form.host_man"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="5">
                                <el-form-item label="监督员2:" prop="cooperate_man">
                                    <el-input size="small" clearable :disabled="states==1?true:false" v-model="form.cooperate_man"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="主案由:" prop="reason2">
                                    <el-input size="small" clearable :disabled="states==1?true:false" v-model="form.reason2"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="从案由:">
                                    <el-input size="small" clearable :disabled="states==1?true:false" v-model="form.reason22" disabled style="width:calc(100% - 210px);"></el-input>&nbsp;
                                    <el-button v-if="states != 1" type="primary" size="small" @click="edit('-1')" >选择从案由</el-button>
                                    <el-button v-if="states != 1" type="danger" size="small" @click="add(form.reason22)" >增加从案由</el-button>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="违反法律:" prop="law">
                                    <el-input size="small" clearable :disabled="states==1?true:false" v-model="form.law"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="处罚依据:" prop="punish_basis">
                                    <el-input size="small" clearable :disabled="states==1?true:false" v-model="form.punish_basis"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item label="接收检测报告:" prop="jc_jieshoudate">
                                    <el-date-picker size="small" clearable :disabled="states==1?true:false"
                                        v-model="form.jc_jieshoudate"
                                        type="date"
                                        placeholder="选择日期" value-format="yyyy-MM-dd">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="告知当事人:" prop="jc_gaozhidate">
                                    <el-date-picker size="small" clearable :disabled="states==1?true:false"
                                        v-model="form.jc_gaozhidate"
                                        type="date"
                                        placeholder="选择日期" value-format="yyyy-MM-dd">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="执法主体:" prop="c_jcjg">
                                    <el-input size="small" clearable :disabled="states==1?true:false" v-model="form.c_jcjg"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item label="处罚结果:" prop="cfjg">
                                    <el-input size="small" clearable :disabled="states==1?true:false" v-model="form.cfjg"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="决定书日期:">
                                    <el-date-picker size="small" clearable :disabled="states==1?true:false"
                                        v-model="form.jds_rq"
                                        type="date"
                                        placeholder="选择日期" value-format="yyyy-MM-dd">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="决定书文号:" prop="cfjdwh">
                                    <el-input size="small" clearable :disabled="states==1?true:false" v-model="form.cfjdwh"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item label="结案日期:" prop="jiean_rq">
                                    <el-date-picker size="small" clearable :disabled="states==1?true:false"
                                        v-model="form.jiean_rq"
                                        type="date"
                                        placeholder="选择日期" value-format="yyyy-MM-dd">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="案情摘要信息:"  prop="textarea1">
                                    <el-input size="small" clearable type="textarea" :rows="5" v-model="form.textarea1"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="案件调查信息:"  prop="textarea2">
                                    <el-input size="small" clearable type="textarea" :rows="5" v-model="form.textarea2"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="证据材料:"  prop="textarea3">
                                    <el-input size="small" clearable type="textarea" :rows="5" v-model="form.textarea3"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="案由:"  prop="textarea4">
                                    <el-input size="small" clearable type="text" v-model="form.textarea4"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="违反法律:"  prop="textarea5">
                                    <el-input size="small" clearable type="textarea" :rows="5" v-model="form.textarea5"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="处罚依据:"  prop="textarea6">
                                    <el-input size="small" clearable type="textarea" :rows="5" v-model="form.textarea6"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="自由裁量:"  prop="textarea7">
                                    <el-input size="small" clearable type="textarea" :rows="5" v-model="form.textarea7"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="处罚金额:"  prop="textarea8">
                                    <el-input size="small" clearable type="text" v-model="form.textarea8"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </div>
                <!-- <div class="bd">
                    <p>案情摘要</p>
                    <div class="nr">
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="现场检查内容:"  prop="content12">
                                    <el-input size="small" clearable type="textarea" :rows="3" v-model="form.content12"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </div> -->

                <el-row>
                    <el-col :span="24">
                        <el-form-item style="text-align:right;" v-if="states != 1">
                            <el-button type="warning" size="small" @click="save2()" >暂存</el-button>
                            <el-button type="primary" size="small" @click="save('form')" >确定</el-button>
                        </el-form-item> 
                    </el-col>
                </el-row>
            </el-col> 
            
            
        </el-form>
        <el-dialog title="增加从案由" :visible.sync="open" top="10vh" width="900px" append-to-body  :close-on-click-modal="false">
            <el-form v-model="form2" label-width="100px">
                <el-form-item
                    v-for="(domain, index) in form2.domains"
                    :label="'从案由'+(index+1)+':'"       
                    :key="domain.key"
                    :prop="'domains.' + index + '.value'"
                   :rules="{
                        required: true, message: '请选择从案由', trigger: 'blur'
                    }"
                >
                    <el-input disabled v-model="domain.value" size="mini" style="width: calc(100% - 300px);"></el-input>&nbsp;
                    <el-button type="primary" size="small" @click="edit(index)" >选择从案由</el-button>&nbsp;
                    <el-button size="mini" type="danger" plain @click.prevent="removeDomain(domain)">删除</el-button>
                    <el-button v-if="index === 0" type="primary" size="small" @click="addDomain(form.reason1)" >增加从案由</el-button>
                </el-form-item>
                <el-form-item style="text-align:right;">
                <el-button type="primary" size="small" @click="getDomain()" >确定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog title="选择从案由" :visible.sync="open2" top="10vh" width="1200px" append-to-body  :close-on-click-modal="false">
            <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="88px" >
                <el-form-item label="专业类别:" prop="zylb">
                    <el-select v-model="queryParams.zylb" placeholder="请选择专业类别" clearable>
                        <el-option
                        v-for="dict in zylxOptions"
                        :key="dict.zylb"
                        :label="dict.zylb"
                        :value="dict.zylb"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="案由名称:" prop="name">
                    <el-input
                    v-model="queryParams.name"
                    placeholder="请输入案由名称"
                    clearable
                    size="small"
                    @keyup.enter.native="handleQuery"
                    />
                </el-form-item>
                <el-form-item>
                    <el-button type="cyan" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
                    <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
                </el-form-item>
                </el-form>

                <el-table v-loading="loading" :data="anyouList">
                <!--<el-table-column type="selection" width="55" align="center" />-->
                <el-table-column label="序号" type="index" width="50" align="center">
                    <template slot-scope="scope">
                    <span>{{(queryParams.pageNum - 1) * queryParams.pageSize + scope.$index + 1}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="专业类别" align="center" prop="zylb" width="150" />
                <!-- <el-table-column label="专业子类" align="center" prop="leibie" width="120" /> -->
                <el-table-column label="案由名称" align="center" prop="anyou" />
                <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="80">
                    <template slot-scope="scope">
                    <el-button
                        size="mini"
                        type="text"
                        icon="el-icon-thumb"
                        @click="handleSelect(scope.row)"
                    >选中</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page-part" style="overflow:hidden;">
                <el-pagination
                    background
                    @current-change='handleCurrentChange'
                    :current-page="queryParams.pageNum"
                    :page-sizes="[10,20,30,40]"
                    :page-size="queryParams.pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="total" style=" float:right;">
                </el-pagination>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
export default {
    name: 'app',
    props:['pcId','states'],
    watch:{
        pcId(val){
            if(val){
                this.getList()
            }
        },
        states(){
            console.log(this.states)
            this.getList()
        },
    },
    data(){
        return{
            form:{},
            rules:{
                jingyingzhe:[
                    { required: true, message: '当事人类型不能为空', trigger: ['change','blur'] }
                ],
                dwmc: [
                    { required: true, message: '当事人不能为空', trigger: 'blur' }
                ],
                dwdz: [
                    { required: true, message: '地址不能为空', trigger: 'blur' }
                ],
                xkzh: [
                    { required: true, message: '许可证号不能为空', trigger: 'blur' }
                ],
                // zzdm: [
                //     { required: true, message: '统一社会信用代码不能为空', trigger: 'blur' }
                // ],
                jingyingzhexm: [
                    { required: true, message: '法定代表人不能为空', trigger: 'blur' }
                ],
                frxb: [
                    { required: true, message: '性别不能为空', trigger: 'blur' }
                ],
                nation: [
                    { required: true, message: '民族不能为空', trigger: 'blur' }
                ],
                sfzh: [
                    { required: true, message: '身份证号不能为空', trigger: 'blur' }
                ],
                sj1: [
                    { required: true, message: '联系电话不能为空', trigger: 'blur' }
                ],
                laiyuan: [
                    { required: true, message: '案件来源不能为空', trigger: 'blur' }
                ],
                jiancha_rq: [
                    { required: true, message: '检查日期不能为空', trigger: 'blur' }
                ],
                shouli_rq: [
                    { required: true, message: '受理日期不能为空', trigger: 'blur' }
                ],
                lian_rq: [
                    { required: true, message: '立案日期不能为空', trigger: 'blur' }
                ],
                heyisj_begin: [
                    { required: true, message: '合议开始日期不能为空', trigger: 'blur' }
                ],
                heyisj_end: [
                    { required: true, message: '合议结束日期不能为空', trigger: 'blur' }
                ],
                host_man: [
                    { required: true, message: '监督员1不能为空', trigger: 'blur' }
                ],
                cooperate_man: [
                    { required: true, message: '监督员2不能为空', trigger: 'blur' }
                ],
                reason2: [
                    { required: true, message: '主案由不能为空', trigger: 'blur' }
                ],
                law: [
                    { required: true, message: '违反法律不能为空', trigger: 'blur' }
                ],
                punish_basis: [
                    { required: true, message: '处罚依据不能为空', trigger: 'blur' }
                ],
                c_jcjg: [
                    { required: true, message: '执法主体不能为空', trigger: 'blur' }
                ],
                penalize: [
                    { required: true, message: '不能为空', trigger: 'blur' }
                ],
                jiean_rq: [
                    { required: true, message: '结案日期不能为空', trigger: ['change','blur'] }
                ],
                content12: [
                    { required: true, message: '现场检查内容不能为空', trigger: 'blur' }
                ],
            },
            open:false,
            form2:{
                domains: []
            },
            open2:false,
            queryParams:{
                pageNum: 1,
                pageSize: 10,
                zylb:'',
                name:''
            },
            zylxOptions:[],
            anyouList:[],
            total:0,
            loading:false,
            DqIndex:0,
            baseUrl:''
        }
    },
    mounted() {
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.baseUrl = user.baseUrl

        axios({
            method: 'post',
            url: this.baseUrl+`/login/getAnyouZylb`,
            data:{},
            headers: { 
                "Content-Type": "application/json"
            },
        }).then(res => {
            if(res.data.code == 0 && res.data.data){
                this.zylxOptions = res.data.data || []
            }else{
                if(res.data.msg){
                    this.$message.error(res.data.msg)
                }
            }
        }).catch(error => {
            this.$message.error(error);
        })
        this.getList()
        this.getList2()
    },
    methods: {
        async getList(){
            this.form = {
                jingyingzhe:'',
                dwmc:'',
                dwdz:'',
                frxb:'',
                nation:'',
                sfzh:'',
                sj1:'',
                wfxwdz:'',
                changsuo:'',
                xkzh:'',
                zzdm:'',
                jingyingzhexm:'',
                frxb:'',
                nation:'',
                frzw:'',
                laiyuan:'',
                jiancha_rq:'',
                shouli_rq:'',
                lian_rq:'',
                heyisj_begin:'',
                heyisj_end:'',
                host_man:'',
                cooperate_man:'',
                reason2:'',
                reason22:'',
                law:'',
                punish_basis:'',
                jc_jieshoudate:'',
                jc_gaozhidate:'',
                c_jcjg:'',
                cfjg:'',
                jds_rq:'',
                cfjdwh:'',
                jiean_rq:'',
            }
            axios({
                method: 'post',
                url: this.baseUrl+`/pdfApi/getAnjianJcxx`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    pcId:this.pcId,
                }
            })
            .then(response => {
                console.log(response.data,613);
                this.form = response.data.data
            })
            .catch(error => {
                console.error('There was an error!', error);
            });
        },
        getList2(){
            this.anyouList = []
            this.total = 0
            axios({
                method: 'post',
                url: this.baseUrl+`/login/getAnyou`,
                data:{
                    zylb:this.queryParams.zylb,
                    name:this.queryParams.name,
                    limit:this.queryParams.pageSize,
                    page:this.queryParams.pageNum            
                },
                headers: { 
                    "Content-Type": "application/json"
                },
            }).then(res => {
                if(res.data.code == 0 && res.data.data){
                    this.anyouList =  res.data.data.list || []
                    this.total = res.data.data.total || 0
                }else{
                    if(res.data.msg){
                        this.$message.error(res.data.msg)
                    }
                }
            }).catch(error => {
                this.$message.error(error);
            })  
        },
        edit(val){
            this.DqIndex = val
            this.open2 = true
        },
        handleQuery(){
            this.queryParams.pageNum = 1;
            this.getList2();
        },
        resetQuery() {
            this.queryParams = {
                pageNum: 1,
                pageSize: 10,
                zylb:'',
                name:''
            }
            this.handleQuery();
        },
        handleSelect(row){
            if(this.form.reason22){
                if(this.form.reason22.indexOf(row.anyou)!='-1'){
                    this.$message({
                        type: "error",
                        message: "案由不能重复"
                    });
                    return;
                }
            }
            this.$confirm("确定要选择这个案由吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
            .then(() => {
                this.open2 = false
                if(this.DqIndex == '-1'){
                    this.form.reason22 = row.anyou
                }else{
                    this.form2.domains[this.DqIndex].value = row.anyou
                }
            })
        },
        handleCurrentChange(val){
            this.queryParams.pageNum = val;
            this.getList2();
        },
        save(form){
            this.$refs[form].validate((valid) => {
                if (valid) {
                    for(var key in this.form){
                        if(this.form[key] == null){
                            this.form[key] = ''
                        }
                    }
                    console.log(this.form)
                    //let form = JSON.stringify(this.form)
                    axios({
                        method: 'post',
                        url: this.Global._baseUrl3+`/login/setAnjianJcxx`,
                        headers: { // 添加请求头
                            "Content-Type": "application/json" // 明确声明为 JSON 格式
                        },
                        data: {
                            pcId:this.pcId,
                            id: this.form.id,
                            c_jcjg: this.form.c_jcjg,
                            cfjg: this.form.cfjg,
                            content12: this.form.content12,
                            cooperate_man: this.form.cooperate_man,
                            dwdz: this.form.dwdz,
                            dwmc: this.form.dwmc,
                            fakuan: this.form.fakuan,
                            frxb: this.form.frxb,
                            frzw: this.form.frzw,
                            heyisj_begin: this.form.heyisj_begin,
                            heyisj_end: this.form.heyisj_end,
                            host_man: this.form.host_man,
                            jds_rq: this.form.jds_rq,
                            jiancha_rq: this.form.jiancha_rq,
                            jianduyuan1: this.form.jianduyuan1,
                            jianduyuan2: this.form.jianduyuan2,
                            jiean_rq: this.form.jiean_rq,
                            jinggao: this.form.jinggao,
                            jingyingzhe: this.form.jingyingzhe,
                            jingyingzhexm: this.form.jingyingzhexm,
                            laiyuan: this.form.laiyuan,
                            law: this.form.law,
                            lian_rq: this.form.lian_rq,
                            nation: this.form.nation,
                            punish_basis: this.form.punish_basis,
                            reason2: this.form.reason2,
                            reason22: this.form.reason22,
                            sfzh: this.form.sfzh,
                            shouli_rq: this.form.shouli_rq,
                            sj1: this.form.sj1,
                            textarea1: this.form.textarea1,
                            textarea2: this.form.textarea2,
                            textarea3: this.form.textarea3,
                            textarea4: this.form.textarea4,
                            textarea5: this.form.textarea5,
                            textarea6: this.form.textarea6,
                            textarea7: this.form.textarea7,
                            textarea8: this.form.textarea8,
                            zhiwu: this.form.zhiwu,
                            zzdm: this.form.zzdm
                        }
                    })
                    .then(res => {
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        this.$emit('callback',true)
                    }).catch(res => {
                        this.$message({
                            message: '保存失败，请重新填写',
                            type: 'error'
                        });
                    })
                }
            })
        },
        save2(){
            for(var key in this.form){
                if(this.form[key] == null ){
                    this.form[key] = ''
                }
            }
            console.log(this.form)
            axios({
                method: 'post',
                url: this.Global._baseUrl3+`/login/setAnjianJcxx`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    pcId:this.pcId,
                    id: this.form.id,
                    c_jcjg: this.form.c_jcjg,
                    cfjg: this.form.cfjg,
                    content12: this.form.content12,
                    cooperate_man: this.form.cooperate_man,
                    dwdz: this.form.dwdz,
                    dwmc: this.form.dwmc,
                    fakuan: this.form.fakuan,
                    frxb: this.form.frxb,
                    frzw: this.form.frzw,
                    heyisj_begin: this.form.heyisj_begin,
                    heyisj_end: this.form.heyisj_end,
                    host_man: this.form.host_man,
                    jds_rq: this.form.jds_rq,
                    jiancha_rq: this.form.jiancha_rq,
                    jianduyuan1: this.form.jianduyuan1,
                    jianduyuan2: this.form.jianduyuan2,
                    jiean_rq: this.form.jiean_rq,
                    jinggao: this.form.jinggao,
                    jingyingzhe: this.form.jingyingzhe,
                    jingyingzhexm: this.form.jingyingzhexm,
                    laiyuan: this.form.laiyuan,
                    law: this.form.law,
                    lian_rq: this.form.lian_rq,
                    nation: this.form.nation,
                    punish_basis: this.form.punish_basis,
                    reason2: this.form.reason2,
                    reason22: this.form.reason22,
                    sfzh: this.form.sfzh,
                    shouli_rq: this.form.shouli_rq,
                    sj1: this.form.sj1,
                    textarea1: this.form.textarea1,
                    textarea2: this.form.textarea2,
                    textarea3: this.form.textarea3,
                    textarea4: this.form.textarea4,
                    textarea5: this.form.textarea5,
                    textarea6: this.form.textarea6,
                    textarea7: this.form.textarea7,
                    textarea8: this.form.textarea8,
                    zhiwu: this.form.zhiwu,
                    zzdm: this.form.zzdm
                }
            })
            .then(res => {
                this.$message({
                    message: '保存成功',
                    type: 'success'
                });
                this.$emit('callback',true)
            }).catch(res => {
                this.$message({
                    message: '保存失败，请重新填写',
                    type: 'error'
                });
            })
        },
        add(reason22){
            this.form2.domains = []
            this.open = true
            let arr = reason22.split('|')
            arr.forEach((item,index) => {
                if(item){
                    this.form2.domains.push({value:item,key:index})
                }
            })
        },
        //增加一行
        addDomain() {
            this.form2.domains.push({
                value: '',
                key: this.form2.domains.length
            });
        },
        //删除
        removeDomain(item) {
            var index = this.form2.domains.indexOf(item)
            if (index !== -1) {
                this.form2.domains.splice(index, 1)
            }
        },
        getDomain(){
            this.form.reason22 = ''
            let arr = []
            this.form2.domains.forEach(item => {
                if(item.value){
                    arr.push(item.value)
                }
            })
            this.form.reason22 = arr.join('|')
            this.open = false
        }
    }
}
</script>

<style scoped>
.xq{max-height: 87vh; overflow: auto;}
.xq >>> .el-input.is-disabled .el-input__inner 
{ color: #606266;}
.bd{ width: calc(100% - 2px); border:1px solid #DCDFE5; margin-bottom: 15px;}
.bd p{ background: #eff2f9; margin: 0; padding: 0 20px; line-height: 34px;color:#000; font-weight: bold; height: 34px; border-bottom: 1px solid #DCDFE5;}
.nr{ padding: 8px 10px 10px;}
.dwxq >>> .el-form-item {
    margin-bottom: 18px;
}
.dwxq >>> .el-form-item.jy {
    margin-bottom: 0px;
}
.dwxq >>> .el-form-item__error{padding-top:0;}
.dwxq >>> .el-form-item__label,.dwxq >>> .el-form-item__content{ line-height: 32px;}
.dwxq >>> .el-date-editor.el-input, .el-date-editor.el-input__inner{ width:100%;}
</style>